import { z } from 'zod';
import { DashboardRole } from './roles.js';

export const InvitationStatus = z.enum(['pending', 'accepted', 'expired', 'revoked']);
export type InvitationStatus = z.infer<typeof InvitationStatus>;

export const Invitation = z.object({
  token: z.string(),
  email: z.string().email(),
  workspace_id: z.string().nullable().optional(),
  role: DashboardRole,
  issuer_email: z.string().email(),
  created_on: z.number().int(),
  expires_on: z.number().int(),
  accepted_on: z.number().int().nullable().optional(),
  revoked_on: z.number().int().nullable().optional(),
  status: InvitationStatus,
});
export type Invitation = z.infer<typeof Invitation>;

export const CreateInvitationRequest = z.object({
  email: z.string().email(),
  workspace_id: z.string().optional(),
  role: DashboardRole,
  ttl_hours: z.number().int().min(1).max(168).default(72),
});
export type CreateInvitationRequest = z.infer<typeof CreateInvitationRequest>;

export const AcceptInvitationRequest = z.object({
  token: z.string(),
  name: z.string().min(1).optional(),
  password: z.string().min(8).optional(),
});
export type AcceptInvitationRequest = z.infer<typeof AcceptInvitationRequest>;
